export const STACKS_TRENDING = '/stacks/trending';
export const STACKS_TOP = '/stacks';
export const STACKS_POPULAR = '/stacks';
export const API_ROUTE = '/api';
